<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 21 19">
    <g clip-path="url(#clip0_6892_9191)">
      <path
        d="M10.4367 0.802734L0 18.8027H21L10.4367 0.802734ZM10.4367 3.30859L18.7961 17.5622H2.17853L10.4493 3.30859H10.4367ZM11.1206 12.5257H9.85404V7.63802H11.1206V12.5257ZM11.7539 15.1184C11.7539 15.8007 11.184 16.3589 10.4873 16.3589C9.79071 16.3589 9.22075 15.8007 9.22075 15.1184C9.22075 14.4361 9.79071 13.8779 10.4873 13.8779C11.184 13.8779 11.7539 14.4361 11.7539 15.1184Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_9191">
        <rect width="21" height="18" fill="white" transform="translate(0 0.802734)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
